import React from 'react';
import {FastField} from "formik";
import {Grid} from "@material-ui/core";
import AreaSelectorContainer from 'data/redux/containers/areaSelectorContainer/AreaSelectorContainer';
import PlaceSelector from 'gui/components/editors/commons/editor/components/placeSelector/PlaceSelector';
import FormikPhoneInput from 'gui/components/formikPhoneInput/FormikPhoneInput';
import FormikTextField from 'gui/components/formikTextField/FormikTextField';

const FieldTypeRestaurant = () => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FastField
          label="איזור"
          name="areasPick"
          component={AreaSelectorContainer}
        />
      </Grid>
      <Grid item xs={12} sm={6}/>
      <Grid item xs={12} sm={6}>
        <FormikPhoneInput
          label="טלפון"
          name="phone"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="אתר"
          name={"websiteUrl"}
          placeholder={"https://www.example.com"}
        />
      </Grid>
      <PlaceSelector
        placeKey={'placeDetails'}
      />
    </>
  );
};

export default React.memo(FieldTypeRestaurant);
